import { VueReactor, ReactorOptions } from '@/api/reactor';
import { action, routeTo } from '@/api/reactor/reactions';

// global reactions
const reactorOptions: ReactorOptions = {
    reactions: {
        '$auth/setAuthenticated': [ action('$sitenotify/open'), routeTo('destinations') ],
        '$auth/setRestored': [ action('$sitenotify/open') ],
        '$auth/setSignedOut': [ action('$sitenotify/close'), routeTo('login') ],
    }
};

const reactor = new VueReactor(reactorOptions);
export default reactor;
